import projectApiPib from "../assets/images/projeto-api-pib.jpg";
import projectEnergia from "../assets/images/projeto-analise-energia.jpg";
import projectEP from "../assets/images/projeto-ep.jpeg";
import projectIA from "../assets/images/projeto-ia-henet.png";
import projectMercadoLivre from "../assets/images/projeto-mercado-livre.jpg";
import projectChaves from "../assets/images/projeto-chaves.jpg";
import projectPortfolio from "../assets/images/novo_portfolio.png";
import projectEdaSemantix from "../assets/images/eda_projeto.jpeg";
import projectQuadrix from "../assets/images/quadrix-desktop.png";
import projectMinhaHenet from "../assets/images/apresentacao-1920x1080.png";
import projectAsesFix from "../assets/images/asesfix-apresentacao.jpg";
import projectMaxima from "../assets/images/projeto-maxima-esquadrias.jpg";
import projectJR from "../assets/images/projeto-jr-distribuidora.jpg";

export const profile = {
  name: "Guybson Lopes",
  role: "Desenvolvedor Full Stack",
  email: "guybsonlopescomercial@gmail.com",
  phone: "+55 77 98118-7169",
  phoneHref: "tel:+5577981187169",
  whatsapp: "https://wa.me/5577981187169",
  github: "https://github.com/GuybsonDev",
  linkedin: "https://www.linkedin.com/in/guybson-lopes-132b7020b/",
  resume:
    "https://drive.google.com/file/d/14V5tuAfT47Wt_rWVyPeqsQGv6Dkn7QMm/view?usp=sharing",
};

export const navItems = [
  { label: "Sobre", id: "sobre" },
  { label: "Serviços", id: "servicos" },
  { label: "Experiência", id: "experiencia" },
  { label: "Projetos", id: "projetos" },
  { label: "Contato", id: "contato" },
];

export const marqueeItems = [
  "React",
  "React Native",
  "Python",
  "Django",
  "Flask",
  "JavaScript",
  "TypeScript",
  "FastAPI",
  "LangGraph",
  "Next.js",
  "Tailwind CSS",
  "SQL",
  "Pandas",
  "Power BI",
  "Looker Studio",
  "AWS",
  "Google Cloud",
  "Git",
  "Linux",
  "Selenium",
  "Streamlit",
  "Docker",
];

export const aboutParagraphs = [
  "Sou desenvolvedor full stack e trabalho na fronteira entre produto e dados. No dia a dia construo aplicações web e mobile, integro sistemas por API e automatizo processos que antes consumiam horas de trabalho manual, hoje também com agentes de IA que buscam em bases próprias e respondem citando a fonte.",
  "A parte de dados veio junto: modelo pipelines, escrevo consultas e entrego dashboards que respondem perguntas de negócio. Isso me permite entregar não só a funcionalidade, mas também a leitura do que ela produz.",
  "Gosto de código organizado, comunicação direta com quem usa o sistema e entregas que resolvem o problema real, não só o ticket.",
];

export const aboutFacts = [
  { label: "Foco", value: "Full Stack · Dados · Automação · IA" },
  { label: "Experiência", value: "3+ anos em produção" },
  { label: "Stack principal", value: "Python · TypeScript · React · SQL" },
  { label: "Entrega", value: "Cloud, Git e métodos ágeis" },
];

export const services = [
  {
    index: "01",
    title: "Aplicações web e mobile",
    description:
      "Desenvolvimento de ponta a ponta, do banco de dados à interface, com foco em usabilidade, responsividade e código sustentável.",
    items: ["React", "React Native", "Django", "Flask", "JavaScript", "Python"],
  },
  {
    index: "02",
    title: "Dados e BI",
    description:
      "Análise exploratória, modelagem de indicadores e dashboards que transformam dados dispersos em decisão de negócio.",
    items: ["Pandas", "Power BI", "Looker Studio", "SQL", "ETL", "Matplotlib"],
  },
  {
    index: "03",
    title: "Integrações e automação",
    description:
      "APIs REST, web scraping, rotinas automatizadas e agentes de IA com RAG sobre bases próprias, para eliminar operação manual e conectar sistemas que não se falam.",
    items: ["REST APIs", "Agentes de IA", "RAG", "LangGraph", "MCP", "Web Scraping"],
  },
  {
    index: "04",
    title: "Cloud e entrega",
    description:
      "Publicação e manutenção de aplicações em ambiente Linux e nuvem, com versionamento e trabalho em cadência ágil.",
    items: ["AWS", "Google Cloud", "Linux", "Git", "GitHub", "Scrum/Kanban"],
  },
];

export const experiences = [
  {
    company: "Henet Manutenção e Serviços Digitais",
    role: "Analista de Desenvolvimento de Sistemas",
    period: "Ago 2023 — Atual",
    current: true,
    highlights: [
      "Desenvolvimento full stack de aplicações web e mobile, do banco de dados à interface, com Python, Django, React, React Native, JavaScript e TypeScript.",
      "Desenvolvimento de agentes de IA com RAG sobre a base de conhecimento da empresa, com respostas que citam a fonte.",
      "Construção e manutenção de sistemas internos, cobrindo backend, API e frontend da mesma entrega.",
      "Integração de sistemas via APIs REST e automação de rotinas operacionais.",
      "Dashboards e relatórios em Power BI e Looker Studio para apoiar decisões da operação.",
      "Publicação e manutenção de aplicações em ambiente Linux e nuvem (AWS / Google Cloud).",
    ],
    stack: [
      "Python",
      "Django",
      "React",
      "React Native",
      "JavaScript",
      "TypeScript",
      "FastAPI",
      "LangGraph",
      "MCP",
      "SQL",
      "Power BI",
      "AWS",
      "Git",
    ],
  },
];

export const projectCategories = [
  "Todos",
  "Full Stack",
  "Web",
  "Dados & BI",
  "Automação & IA",
  "Mobile",
];

export const projects = [
  {
    title: "Minha He-net — app cliente",
    categories: ["Mobile", "Full Stack"],
    featured: true,
    description:
      "App cliente da He-net, publicado na App Store e no Google Play. O cliente paga a fatura por PIX, código de barras ou boleto, troca o nome e a senha do Wi-Fi, testa a velocidade da conexão, vê os dispositivos conectados e acompanha chamados com técnico e protocolo — tudo sem precisar ligar para a central. Backend em Django rodando em EC2, com notificações push para faturas e andamento de atendimento.",
    image: projectMinhaHenet,
    // Peça de apresentação já composta: exibe inteira, sem corte, sobre o
    // próprio fundo da arte.
    imageFit: "contain",
    imageBackground: "#06141e",
    metrics: ["+42 mil downloads", "iOS e Android"],
    links: [
      {
        label: "Google Play",
        href: "https://play.google.com/store/apps/details?id=com.minhahenet&hl=pt_BR",
      },
      {
        label: "App Store",
        href: "https://apps.apple.com/br/app/minha-he-net/id1528996775",
      },
    ],
    stack: ["React Native", "Django", "AWS EC2", "Push Notifications", "REST API"],
  },
  {
    title: "Máxima Esquadrias — site e catálogo digital",
    year: "2026",
    categories: ["Web"],
    description:
      "Site institucional e catálogo digital da Máxima Esquadrias, indústria de esquadrias de alumínio. Apresenta 35 produtos nas linhas Quality, Premium, Premium Cerejeira, Wood e Inox, cada um com página própria, filtro por categoria que pode ser compartilhado por link e pedido de catálogo que chega pronto ao WhatsApp da equipe de vendas. Totalmente estático, sem back-end nem CMS, com dados estruturados para busca, sitemap e fontes servidas do próprio domínio.",
    image: projectMaxima,
    metrics: ["Site no ar", "35 produtos em 5 linhas"],
    links: [{ label: "Visitar site", href: "https://www.maximaindustria.com.br" }],
    stack: ["Next.js", "React", "TypeScript", "Tailwind CSS", "SEO"],
  },
  {
    title: "JR Distribuidora — site e catálogo digital",
    year: "2026",
    categories: ["Web"],
    description:
      "Site institucional e catálogo da JR Distribuidora e Indústria, com 42 produtos em 7 categorias: portas e janelas sob medida, perfis de alumínio, iluminação LED, ferragens, comunicação visual e linha inox. Cada produto ganha página própria a partir de arquivos TypeScript, e o pedido de catálogo sai do formulário direto para o WhatsApp da empresa. Sem banco e sem CMS, com sitemap e dados estruturados para busca.",
    image: projectJR,
    metrics: ["Site no ar", "42 produtos em 7 categorias"],
    links: [{ label: "Visitar site", href: "https://www.jrindustria.com.br" }],
    stack: ["Next.js", "React", "TypeScript", "Tailwind CSS", "SEO"],
  },
  {
    title: "AsesFix — plataforma de manutenção residencial",
    year: "2026",
    categories: ["Mobile", "Web", "Full Stack"],
    description:
      "Plataforma construída para a ASES Construtora, com três perfis de acesso: cliente, técnico e administrativo. Cobre a ordem de serviço de ponta a ponta — abertura pelo morador, atribuição por agenda que respeita escala e competência do técnico, execução com evidência fotográfica de antes e depois mais assinatura do cliente, e painel com SLA, taxa de conclusão, tempo médio e faturamento em tempo real. App iOS e Android somado a painel web, com backend Django hospedado em EC2.",
    image: projectAsesFix,
    // Peça de apresentação composta: exibe inteira sobre o fundo da própria arte.
    imageFit: "contain",
    imageBackground: "#071a3e",
    metrics: ["iOS, Android e Web", "3 perfis de acesso"],
    links: [{ label: "Visitar site", href: "https://asesfix.com.br" }],
    stack: ["Django", "Python", "React Native", "React", "AWS EC2"],
  },
  {
    title: "Quadrix — SaaS de agendamento de quadras",
    year: "2025",
    categories: ["Full Stack"],
    description:
      "Plataforma B2B para agendamento e gestão de quadras esportivas: reservas por modalidade e horário, confirmação de presença em tempo real, painéis separados para administrador e participante, além de métricas e relatórios de operação. Interface construída com responsividade total.",
    image: projectQuadrix,
    link: "https://github.com/GuybsonDev",
    stack: ["Django", "Django Ninja", "React", "TanStack Query", "SaaS"],
  },
  {
    title: "EDA de Marketing Digital — parceria Semantix",
    year: "2025",
    categories: ["Dados & BI"],
    description:
      "Análise exploratória de campanhas de marketing com dashboard no Looker Studio: KPIs, eficiência por canal e insights acionáveis, com base MySQL local alimentando o pipeline.",
    image: projectEdaSemantix,
    link: "https://github.com/GuybsonDev",
    stack: ["Python", "Pandas", "ETL", "MySQL", "Looker Studio"],
  },
  {
    title: "He-Net Knowledge Agent",
    year: "2024",
    categories: ["Automação & IA", "Full Stack"],
    description:
      "Sistema de perguntas e respostas sobre o site da He-Net. Um crawler em Python lê o sitemap e a API do WordPress, divide o texto em trechos e indexa no Chroma (vetores) e no BM25 (palavras). Um agente em LangGraph busca, avalia os trechos, reescreve a consulta se preciso e responde em streaming citando as páginas de origem. Exposto por API FastAPI com SSE, servidor MCP e frontend em Next.js. Modelos OpenAI ou Anthropic, Docker, pytest e GitHub Actions.",
    image: projectIA,
    metrics: ["Agente RAG em LangGraph", "Streaming com fontes citadas"],
    link: "https://github.com/GuybsonDev/Treinamento-IA-Base-Henet",
    stack: [
      "Python",
      "TypeScript",
      "FastAPI",
      "LangGraph",
      "OpenAI",
      "Chroma",
      "Next.js",
      "Tailwind",
      "MCP",
      "Docker",
    ],
  },
  {
    title: "Portfólio profissional",
    year: "2024",
    categories: ["Full Stack"],
    description:
      "Portal com foco em narrativa técnica: stack, experiência, projetos e contato direto, com design system próprio e tema claro/escuro.",
    image: projectPortfolio,
    link: "https://github.com/GuybsonDev/portfolio_guybsonl",
    stack: ["React", "Framer Motion", "CSS", "UI Design"],
  },
  {
    title: "App gerador e cofre de senhas",
    year: "2024",
    categories: ["Mobile"],
    description:
      "Aplicativo mobile para gerar, salvar e gerenciar senhas localmente, com foco em usabilidade e persistência offline.",
    image: projectChaves,
    link: "https://github.com/GuybsonDev/App-Gerador-de-Senhas",
    stack: ["React Native", "Expo", "JavaScript", "UX"],
  },
  {
    title: "Análise de vendas do Mercado Livre",
    year: "2024",
    categories: ["Dados & BI", "Automação & IA"],
    description:
      "Consumo da API do Mercado Livre e visualização de indicadores comerciais para vendedores: leitura de produto, volume e oportunidades de precificação.",
    image: projectMercadoLivre,
    link: "https://github.com/GuybsonDev/Dashboard-Mercado-Livre",
    stack: ["Python", "APIs", "Pandas", "Streamlit"],
  },
  {
    title: "Sistema de estoque e gestão financeira",
    year: "2023",
    categories: ["Full Stack"],
    description:
      "Aplicação para controle de estoque e financeiro, com estrutura preparada para evoluir em analytics e banco relacional robusto.",
    image: projectEP,
    link: "https://github.com/GuybsonDev/EP",
    stack: ["Python", "SQLite", "Streamlit", "Pandas"],
  },
  {
    title: "Dashboard de consumo de energia",
    year: "2023",
    categories: ["Dados & BI"],
    description:
      "Análise sobre dados reais da UFU com KPIs e visualizações dinâmicas para leitura de comportamento de consumo energético.",
    image: projectEnergia,
    link: "https://app.powerbi.com/view?r=eyJrIjoiYjBhYzRjNzEtODk4MS00OTk0LTgzMGMtZTBiNjY3YTU1M2RlIiwidCI6ImJlN2JmNTQwLTMyMTQtNGE1Ny1hY2U2LWVkZWY3YTE3YjNhZCJ9&embedImagePlaceholder=true",
    stack: ["Power BI", "Python", "Pandas", "BI"],
  },
  {
    title: "API de PIB dos países africanos",
    year: "2023",
    categories: ["Dados & BI", "Full Stack"],
    description:
      "API REST com filtros por período para explorar 63 anos de dados econômicos, aplicando Flask, Pandas e boas práticas de consumo.",
    image: projectApiPib,
    link: "https://github.com/GuybsonDev/API-Analise-PIB-Africano",
    stack: ["Flask", "Python", "Pandas", "REST API"],
  },
];

// Definido depois de `projects` para o contador nunca desatualizar.
export const heroStats = [
  { value: "3+", label: "anos de experiência" },
  { value: String(projects.length), label: "projetos publicados" },
];
